/* Starbound Letters — product page (Shopify edition): gallery, format pills,
   personalization checks, add to cart via the Cart API, wishlist, sticky bar */
(function () {
  "use strict";
  const SB = window.SB;
  const form = document.querySelector("[data-buy-form]");
  if (!form || !SB) return;
  const handle = form.dataset.productHandle;

  /* gallery */
  const main = document.querySelector("[data-gallery-main]");
  const mainImg = () => main && main.querySelector("img");
  document.querySelectorAll("[data-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const t = btn.querySelector("img");
      const m = mainImg();
      if (t && m) {
        m.src = t.currentSrc || t.src;
        m.srcset = t.srcset || "";
        m.dataset.full = t.dataset.full || "";
      }
      document.querySelectorAll("[data-thumb]").forEach((b) => b.setAttribute("aria-current", "false"));
      btn.setAttribute("aria-current", "true");
    });
  });

  /* zoom dialog */
  const zoom = document.querySelector("[data-zoom]");
  if (main && zoom) {
    const open = () => {
      const m = mainImg();
      if (!m) return;
      zoom.querySelector("img").src = m.dataset.full || m.currentSrc || m.src;
      if (typeof zoom.showModal === "function") zoom.showModal();
    };
    main.addEventListener("click", open);
    main.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); } });
    zoom.querySelector("[data-zoom-close]").addEventListener("click", () => zoom.close());
    zoom.addEventListener("click", (e) => { if (e.target === zoom) zoom.close(); });
  }

  /* quantity */
  const qty = form.querySelector("#qty");
  const clampQty = () => { qty.value = String(Math.min(99, Math.max(1, parseInt(qty.value, 10) || 1))); };
  form.querySelector("[data-qty-dec]").addEventListener("click", () => { qty.value = String((parseInt(qty.value, 10) || 1) - 1); clampQty(); });
  form.querySelector("[data-qty-inc]").addEventListener("click", () => { qty.value = String((parseInt(qty.value, 10) || 1) + 1); clampQty(); });
  qty.addEventListener("change", clampQty);

  /* Santa (adults): "signed with a personal name" reveals the name field */
  const signerField = form.querySelector("[data-signer-field]");
  if (signerField) {
    const signerInput = signerField.querySelector("input");
    const paintSigner = () => {
      const personal = form.querySelector("[data-signed-choice]:checked");
      const show = !!(personal && /personal/i.test(personal.value));
      signerField.hidden = !show;
      signerInput.required = show;
      if (!show) { signerInput.value = ""; signerField.classList.remove("invalid"); }
    };
    form.querySelectorAll("[data-signed-choice]").forEach((r) => r.addEventListener("change", paintSigner));
    paintSigner();
  }

  function validatePers() {
    let ok = true;
    form.querySelectorAll("[data-field]").forEach((f) => {
      if (f.hidden) return;
      const inp = f.querySelector("input,textarea");
      if (!inp) return;
      const bad = inp.required && (inp.type === "file" ? !(inp.files && inp.files[0]) : !inp.value.trim());
      f.classList.toggle("invalid", !!bad);
      if (bad && ok) { inp.focus(); ok = false; }
    });
    return ok;
  }

  /* price follows the chosen Format (variant) */
  function currentVariant() {
    return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
  }
  function paintPrice() {
    const v = currentVariant();
    if (!v || !v.dataset.price) return;
    const el = document.querySelector("[data-price]");
    if (el) el.innerHTML = "<span>" + SB.money(v.dataset.price) + "</span>";
    const st = document.querySelector("[data-price-sticky]");
    if (st) st.textContent = SB.money(v.dataset.price);
  }
  form.querySelectorAll('input[name="id"]').forEach((i) => i.addEventListener("change", paintPrice));
  paintPrice();

  const status = form.querySelector("[data-buy-status]");
  const submitBtn = form.querySelector("[data-add-to-cart]");
  let busy = false;

  function addToCart() {
    if (busy) return;
    if (!validatePers()) { SB.status(status, "Please complete the personalization fields above.", "error"); return; }
    const v = currentVariant();
    if (v && v.disabled) { SB.status(status, "That format is sold out right now.", "error"); return; }
    /* A photo upload needs the classic form post (the Cart API can't carry files) */
    const fileInput = Array.from(form.querySelectorAll('input[type="file"]')).find((i) => i.files && i.files[0]);
    if (fileInput) { form.submit(); return; }

    busy = true;
    submitBtn.classList.add("loading");
    submitBtn.disabled = true;
    const fd = new FormData(form);
    /* drop empty optional properties so the cart stays tidy */
    for (const [k, val] of Array.from(fd.entries())) {
      if (k.startsWith("properties[") && typeof val === "string" && !val.trim()) fd.delete(k);
    }
    SB.addToCart(fd)
      .then((item) => {
        const title = document.querySelector(".pdp-info h1")?.textContent.trim() || item.product_title;
        const fmt = v && v.dataset.title && v.dataset.title !== "Default Title" ? " — " + v.dataset.title : "";
        SB.status(status, `Added to cart ✦ ${title}${fmt}`, "success");
        return SB.renderCount();
      })
      .catch((err) => {
        SB.status(status, (err && (err.description || err.message)) || "Sorry — that couldn't be added. Please try again.", "error");
      })
      .finally(() => { busy = false; submitBtn.classList.remove("loading"); submitBtn.disabled = false; });
  }
  form.addEventListener("submit", (e) => { e.preventDefault(); addToCart(); });

  /* wishlist */
  const wishBtn = form.querySelector("[data-wishlist-add]");
  if (wishBtn) {
    const paintWish = () => { wishBtn.textContent = SB.wishlist().includes(handle) ? "Saved to Wishlist ✦" : "Save to Wishlist"; };
    wishBtn.addEventListener("click", () => { SB.toggleWish(handle); paintWish(); });
    paintWish();
  }

  /* sticky mobile buy bar */
  const sticky = document.querySelector("[data-sticky-buy]");
  if (sticky) {
    if ("IntersectionObserver" in window && submitBtn) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting;
        sticky.classList.toggle("active", show);
        document.body.classList.toggle("has-sticky", show);
      });
      io.observe(submitBtn);
    }
    sticky.querySelector("[data-sticky-add]").addEventListener("click", addToCart);
  }
})();
